import actions from './actions';

const initState = {
  logsHistory: []
};

export default function reducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_LOGS_SUCCESS:
      return {
        ...state,
        logsHistory: action.logsHistory,
      };

    default:
      return state;
  }
}
